<script lang="ts" setup>
import type { FiltersEvents } from '../filters';
import { Filters } from '../filters';

import type {
  FlightsFilterEvents,
  FlightsFilterType,
  FlightsFilters,
} from './FlightsFilters.model';
import { FlightsFiltersEventType } from './FlightsFilters.model';

interface FlightsFiltersProps {
  data: FlightsFilters;
}

const props = defineProps<FlightsFiltersProps>();

interface FlightsFiltersViewEmits {
  (eventName: 'update', context: FlightsFilterEvents): void;
}

const emit = defineEmits<FlightsFiltersViewEmits>();

function update(data: FiltersEvents, filterType: FlightsFilterType): void {
  const context = {
    eventType: FlightsFiltersEventType.UpdateFilter,
    filterType,
    data,
  } as FlightsFilterEvents;
  emit('update', context);
}
</script>

<template>
  <div class="flights-filters">
    <div class="filter">
      <p class="label">{{ props.data.numberOfStops.label }}</p>
      <Filters
        :data="props.data.numberOfStops.filters"
        @update="update($event, props.data.numberOfStops.filterType)"
      />
    </div>

    <div class="filter">
      <p class="label">{{ props.data.departureTime.label }}</p>
      <Filters
        :data="props.data.departureTime.filters"
        @update="update($event, props.data.departureTime.filterType)"
      />
    </div>

    <div class="filter">
      <p class="label">{{ props.data.arrivalTime.label }}</p>
      <Filters
        :data="props.data.arrivalTime.filters"
        @update="update($event, props.data.arrivalTime.filterType)"
      />
    </div>

    <div class="filter">
      <p class="label">{{ props.data.travelDuration.label }}</p>
      <Filters
        :data="props.data.travelDuration.filters"
        @update="update($event, props.data.travelDuration.filterType)"
      />
    </div>

    <div class="filter">
      <p class="label">{{ props.data.price.label }}</p>
      <Filters
        :data="props.data.price.filters"
        @update="update($event, props.data.price.filterType)"
      />
    </div>

    <div v-if="props.data.carriers.data.length" class="filter">
      <p class="label">{{ props.data.carriers.label }}</p>
      <div
        v-for="filterData of props.data.carriers.data"
        :key="filterData.title"
        class="filters-group"
      >
        <p class="title">{{ filterData.title }}</p>
        <Filters
          :data="filterData.filters"
          @update="update($event, props.data.carriers.filterType)"
        />
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
.flights-filters {
  display: flex;
  flex-direction: column;
  height: 100%;

  .filter {
    padding-bottom: var(--spacing-16);

    .label {
      @include font-label-xl-bold;
      margin-bottom: var(--spacing-24);
    }

    .title {
      @include font-label-l-light;
    }

    .filters-group {
      padding-bottom: var(--spacing-8);
    }
  }
}
</style>
